import React from 'react';
import './App.css';
// Components
import NavBar from './components/layout/NavBar';
import Main from './components/Main';

function App() {
  return (
    <div className="App">
      <NavBar />
      <Main />
    </div>
  );
}

export default App;
